import React, { Component } from "react";
import { Button } from "react-bootstrap";
//import { mockAxios } from "./../../../theme";
import axios from 'axios';
import SimpleReactValidator from 'simple-react-validator';
import { Helmet } from "react-helmet";
import { toAbsoluteUrl } from "../../../theme";
import queryString from 'query-string';
//import { Link, useLocation } from "react-router-dom";
import * as auth from "../../store/ducks/auth.duck";
import { connect } from "react-redux";
import { toast } from 'react-toastify';

var CryptoJS = require("crypto-js");
let key = process.env.REACT_APP_CRYPTO_KEY


class PasswordChange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      "firstname": "", "lastname": "", "phone": "",
      "emailid": "", "password": "", "usertype": "", "cPassword": "", passLength: false, userId: 0,
      errors: {
        firstName: '',
        emailId: '',
        password: '',
      },
    };
    this.passwordRef = React.createRef();
    this.handleFormFields = this.handleFormFields.bind(this);
    this.submitHandler = this.submitHandler.bind(this);
    this.leaveHandle = this.leaveHandle.bind(this);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
  }

  componentDidMount() {

    const values = queryString.parse(this.props.location.search)
    let data = JSON.stringify({
      userToken: values.token
    })
    axios.post(process.env.REACT_APP_NODE_ENV + '/api/users/getUserDatabyToken', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(data => {
      this.setState({ userId: data.data[0].id });
    });
  }

  handleFormFields = (event) => {
    this.validator.showMessageFor(event.target.name)
    switch (event.target.id) {
      case "upassword":
        this.setState({ "password": event.target.value });
        break;
      case "ucpass":
        this.setState({ "cPassword": event.target.value });
        break;
      default:
        break;
    }
  };

  submitHandler = () => {
    if (this.validator.allValid()) {
      if (this.state.userId !== 0) {
        let postUserData = {
          id: this.state.userId, userPassword: this.state.password
        };
        postUserData = CryptoJS.AES.encrypt(JSON.stringify(postUserData), key).toString()
        this.props.logout();
        fetch(process.env.REACT_APP_NODE_ENV + '/api/users/updateUser', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
          },
          body: JSON.stringify({ data: postUserData })
        }).then((response) => response.json())
          .then(data => {
            this.props.history.push("/auth/login");
            toast.success("Password updated successfully!!!", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000
            });
          })
        //this.props.history.push("/auth");
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }

  }

  leaveHandle = (event) => {
    event.preventDefault();
    this.validator.showMessageFor(event.target.name)
    const { id, value } = event.target;
    let errors = this.state.errors;

    switch (id) {
      case 'upassword':
        errors.password =
          value.length < 8
            ? 'Password must be 8 characters long!'
            : '';
        if (value.length < 8) {
          this.setState({ passLength: true });
        }
        else {
          this.setState({ passLength: false });
        }
        break;
      default:
        break;
    }

    this.setState({ errors, [id]: value }, () => {
      console.log(errors)
    })
  }

  render() {
    return (
      <>
        {/* https://github.com/nfl/react-helmet */}
        <Helmet>
          {/* <link
            type="text/css"
            rel="stylesheet"
            href={toAbsoluteUrl(
                "/assets/css/demo1/style.bundle.css"
            )}
        />
        <link
          type="text/css"
          rel="stylesheet"
          href={toAbsoluteUrl(
            "/assets/css/demo1/pages/login/login-1.css"
          )}
        /> */}
        </Helmet>

        <div className="kt-grid kt-grid--ver kt-grid--root">
          <div
            id="kt_login"
            className="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1"
          >
            <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
              <div
                className="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
                style={{
                  backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-3.jpg")})`
                }}
              >
                {/* <div className="kt-grid__item">
                <Link to="/" > */}
                {/* <center><img
                    alt="Logo"
                    src={toAbsoluteUrl("/media/logos/GoWatr12.png")}
                  />
                  </center> */}

                {/* </Link>
              </div> */}
                <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
                  <div className="kt-grid__item kt-grid__item--middle">
                    <div>
                      {/* <h3 className="kt-login__title" style={{textAlign:'center',wordSpacing:'20px'}}><center>&nbsp; Welcome    to <img
                    alt="Logo"
                    src={toAbsoluteUrl("/media/logos/logo-light.png")}
                  /></center>
                  </h3> */}
                    </div>
                  </div>
                </div>
                <div className="kt-grid__item">
                  <div className="kt-login__info">
                    <div className="kt-login__copyright">&copy; 2019 GoWater</div>
                    <div className="kt-login__menu">
                      {/* <Link to="/terms" className="kt-link">
                      Privacy
                    </Link>
                    <Link to="/terms" className="kt-link">
                      Legal
                    </Link>
                    <Link to="/terms" className="kt-link">
                      Contact
                    </Link> */}
                    </div>
                  </div>
                </div>
              </div>

              <div className="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper">
                <form>
                  <div className="kt-heading kt-heading--md">Reset Password</div>
                  <div className="kt-form__section kt-form__section--first">
                    <div className="kt-wizard-v1__form">
                      <div className="row">
                        <div className="col-xs-2">
                          <div className="form-group">
                            <label>New Password</label>
                            <input type="password" className="form-control" ref={this.passwordRef} required name="Password" id="upassword" placeholder="Enter Your Password" value={this.state.password} onChange={this.handleFormFields} onBlur={this.leaveHandle} />
                            {
                              this.validator.message('Password', this.state.password, 'required|max:20|min:8')
                            }
                            {/* {
                                            this.state.passLength &&
                                            <span className="form-text text-muted"><div style={{ color: 'Red' }}>Password Must Be Minimum 8 characters</div></span>
                                        } */}
                          </div>
                        </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div className="col-xs-2">
                          <div className="form-group">
                            <label>Confirm Password</label>
                            <input type="password" className="form-control" required name="Confirm Password" id="ucpass" placeholder="Confirm Your Password" value={this.state.cPassword} onChange={this.handleFormFields}
                            />
                            {this.validator.message('Confirm Password', this.state.cPassword, `required|in:${this.state.password}`, { messages: { in: 'Passwords need to match!' } })}

                          </div>
                        </div></div>
                      <div className="form-group">
                        <Button variant="outline-success" className="btn-sm btn-bold float-left" style={{ marginLeft: "5px" }} onClick={this.submitHandler} >Submit</Button>
                        {/* <Button variant="outline-success" className="btn-sm btn-bold float-left" style={{ marginLeft: "5px" }} onClick={()=>{ this.props.history.push("/auth")}} >Back</Button> */}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

//export default PasswordChange;

// const mapStateToProps = (state /*, ownProps*/) => {
//     return {
//       userRole: state.auth.user[0].userType  
//     }
//   }

//   export default connect(
//     mapStateToProps,
//     null
//   )(MenuList)



export default
  connect(
    null,
    auth.actions
  )(PasswordChange);